import $ from 'jquery';

const Tabs = () => {
    $('#js-tabs-nav').on('change', (e) => {
        const value = e.target.value;
        window.location.hash = value;
    });

    $(window).on('hashchange', function() {
        changeByHash();
    });

    if (window.location.hash) {
        changeByHash();
    }

    function changeByHash() {
        var hash = window.location.hash;

        if (!hash) {
            return;
        }

        $('.tabs__section').hide();
        $('.tabs__item a').removeClass('tabs__button--active');
        $(`[href="${hash}"]`).addClass('tabs__button--active');
        $(`[data-section="${hash.substring(1)}"]`).show();
    }
};

export default Tabs;
